/* Ted's General Store — Cart Drawer
   Vanilla JS over the Shopify AJAX Cart API. No frameworks.
   Exposes window.tgsCart = { open, close, refresh }. */
(function () {
  'use strict';

  var SELECTORS = {
    root: '[data-tgs-cart-drawer]',
    overlay: '[data-tgs-cart-overlay]',
    panel: '[data-tgs-cart-panel]',
    close: '[data-tgs-cart-close]',
    body: '[data-tgs-cart-body]',
    items: '[data-tgs-cart-items]',
    heading: '[data-tgs-cart-heading]',
    pickup: '[data-tgs-cart-pickup]',
    foot: '[data-tgs-cart-foot]',
    subtotal: '[data-tgs-cart-subtotal]',
    emptyTemplate: '[data-tgs-cart-empty-template]'
  };

  var root;
  var lastFocused = null;

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ---------- helpers ---------- */

  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $all(sel, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(sel));
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Format cents to a money string using the shop's money format when available.
  function formatMoney(cents) {
    cents = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    var format =
      (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    function withCommas(num) {
      var parts = num.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
      return parts.join('.');
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
      var value = '';
      switch (token) {
        case 'amount':
          value = withCommas((cents / 100).toFixed(2));
          break;
        case 'amount_no_decimals':
          value = withCommas(Math.round(cents / 100).toFixed(0));
          break;
        case 'amount_with_comma_separator':
          value = (cents / 100)
            .toFixed(2)
            .replace('.', ',')
            .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = Math.round(cents / 100)
            .toString()
            .replace(/(\d)(?=(\d{3})+$)/g, '$1.');
          break;
        case 'amount_with_space_separator':
          value = (cents / 100)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');
          break;
        default:
          value = (cents / 100).toFixed(2);
      }
      return value;
    });
  }

  function request(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && data.description) || 'Cart request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCart() {
    return request(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', {
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin'
    });
  }

  function changeLine(key, quantity) {
    return request('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function addLine(formData) {
    var body = {};
    formData.forEach(function (value, name) {
      // Build a plain object; properties[...] handled below if present.
      if (/^properties\[/.test(name)) {
        body.properties = body.properties || {};
        var prop = name.slice(name.indexOf('[') + 1, name.indexOf(']'));
        body.properties[prop] = value;
      } else {
        body[name] = value;
      }
    });
    if (body.quantity) body.quantity = parseInt(body.quantity, 10) || 1;
    return request('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  /* ---------- rendering ---------- */

  function buildItemRow(item) {
    var key = escapeHtml(item.key);
    var img = item.image
      ? '<img src="' + escapeHtml(item.image) +
        '" alt="' + escapeHtml(item.product_title || item.title) +
        '" width="72" height="72" loading="lazy">'
      : '';

    var variant = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      variant = '<div class="tgs-cd__variant mono">' + escapeHtml(item.variant_title) + '</div>';
    }

    return '' +
      '<div class="tgs-cd__item" data-tgs-cart-item data-key="' + key + '">' +
        '<div class="tgs-cd__thumb">' + img + '</div>' +
        '<div class="tgs-cd__info">' +
          '<a href="' + escapeHtml(item.url) + '" class="tgs-cd__title">' +
            escapeHtml(item.product_title || item.title) +
          '</a>' +
          variant +
          '<div class="tgs-cd__unit mono">' + formatMoney(item.final_price) + ' ea</div>' +
          '<div class="tgs-cd__controls">' +
            '<div class="tgs-cd__stepper" role="group" aria-label="Quantity">' +
              '<button type="button" class="tgs-cd__step" data-tgs-cart-minus data-key="' + key + '" aria-label="Decrease quantity">−</button>' +
              '<span class="tgs-cd__qty mono" data-tgs-cart-qty>' + item.quantity + '</span>' +
              '<button type="button" class="tgs-cd__step" data-tgs-cart-plus data-key="' + key + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="tgs-cd__remove mono" data-tgs-cart-remove data-key="' + key + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="tgs-cd__lineprice">' +
          '<div class="tgs-cd__lp display">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>' +
      '</div>';
  }

  function renderEmpty(body) {
    var tpl = $(SELECTORS.emptyTemplate);
    if (tpl && 'content' in tpl) {
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
    } else {
      body.innerHTML =
        '<div class="tgs-cd__empty">' +
          '<h3 class="tgs-cd__empty-title display">Your cart is empty</h3>' +
          '<a href="/collections/all" class="btn btn-yellow tgs-cd__empty-cta" data-tgs-cart-close>Shop all</a>' +
        '</div>';
    }
  }

  function render(cart) {
    if (!root) return;

    // Update every count element on the page.
    $all('[data-tgs-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var heading = $(SELECTORS.heading, root);
    if (heading) {
      heading.textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
    }

    var pickup = $(SELECTORS.pickup, root);
    var foot = $(SELECTORS.foot, root);
    var body = $(SELECTORS.body, root);

    if (!cart.items || cart.items.length === 0) {
      if (pickup) pickup.hidden = true;
      if (foot) foot.hidden = true;
      if (body) renderEmpty(body);
      return;
    }

    if (pickup) pickup.hidden = false;
    if (foot) foot.hidden = false;

    if (body) {
      var rows = cart.items.map(buildItemRow).join('');
      body.innerHTML = '<div class="tgs-cd__items" data-tgs-cart-items>' + rows + '</div>';
    }

    var subtotal = $(SELECTORS.subtotal, root);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }

  /* ---------- state / busy ---------- */

  function setBusy(on) {
    if (!root) return;
    root.classList.toggle('is-busy', !!on);
  }

  function refresh() {
    return getCart()
      .then(function (cart) {
        render(cart);
        return cart;
      })
      .catch(function (e) {
        // Defensive: never throw out of the public API.
        if (window.console) console.warn('[tgsCart] refresh failed', e);
      });
  }

  /* ---------- open / close ---------- */

  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function open() {
    if (!root) return;
    // Remember what had focus so we can restore it on close.
    if (document.activeElement && document.activeElement !== document.body) {
      lastFocused = document.activeElement;
    }
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    focusEl($(SELECTORS.close, root));
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    // Return focus to the element that opened the drawer.
    if (lastFocused && document.contains(lastFocused)) {
      focusEl(lastFocused);
    }
    lastFocused = null;
  }

  // Keep Tab focus inside the open panel.
  function trapFocus(e) {
    if (e.key !== 'Tab' || !isOpen()) return;
    var panel = $(SELECTORS.panel, root);
    if (!panel) return;
    var nodes = $all(FOCUSABLE, panel).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (nodes.length === 0) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      focusEl(last);
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      focusEl(first);
    } else if (!panel.contains(document.activeElement)) {
      e.preventDefault();
      focusEl(first);
    }
  }

  function isOpen() {
    return !!(root && root.classList.contains('is-open'));
  }

  /* ---------- line operations ---------- */

  function updateQty(key, quantity) {
    if (!key) return;
    setBusy(true);
    changeLine(key, Math.max(0, quantity))
      .then(function (cart) { render(cart); })
      .catch(function (e) {
        if (window.console) console.warn('[tgsCart] change failed', e);
        return refresh();
      })
      .then(function () { setBusy(false); });
  }

  function findRow(target) {
    var el = target.closest ? target.closest('[data-tgs-cart-item]') : null;
    return el;
  }

  function currentQty(row) {
    var q = row && $('[data-tgs-cart-qty]', row);
    return q ? parseInt(q.textContent, 10) || 0 : 0;
  }

  /* ---------- event wiring ---------- */

  function onDocumentClick(e) {
    var t = e.target;
    // Guard against text/SVG nodes that lack .closest in some browsers.
    if (t && !t.closest && t.parentElement) t = t.parentElement;
    if (!t || !t.closest) return;

    // Open triggers.
    var trigger = t.closest('[data-tgs-cart], [data-tgs-cart-toggle]');
    if (trigger) {
      e.preventDefault();
      open();
      refresh();
      return;
    }

    if (!root) return;

    // Close triggers (X, overlay, empty-state CTA marked data-tgs-cart-close
    // that is NOT a navigating link — links to /collections still navigate).
    var closeTrigger = t.closest('[data-tgs-cart-close], [data-tgs-cart-overlay]');
    if (closeTrigger) {
      // Allow real navigation links to proceed (e.g. "Shop all").
      var isLink = closeTrigger.tagName === 'A' && closeTrigger.getAttribute('href');
      if (!isLink) {
        e.preventDefault();
      }
      close();
      return;
    }

    // Only handle line ops when drawer is open.
    if (!isOpen()) return;

    var minus = t.closest('[data-tgs-cart-minus]');
    if (minus) {
      e.preventDefault();
      var rowM = findRow(minus);
      updateQty(minus.getAttribute('data-key'), currentQty(rowM) - 1);
      return;
    }

    var plus = t.closest('[data-tgs-cart-plus]');
    if (plus) {
      e.preventDefault();
      var rowP = findRow(plus);
      updateQty(plus.getAttribute('data-key'), currentQty(rowP) + 1);
      return;
    }

    var remove = t.closest('[data-tgs-cart-remove]');
    if (remove) {
      e.preventDefault();
      updateQty(remove.getAttribute('data-key'), 0);
      return;
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && isOpen()) {
      close();
      return;
    }
    trapFocus(e);
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-tgs-add-form]')) return;
    e.preventDefault();
    setBusy(true);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

    addLine(new FormData(form))
      .then(function () { return refresh(); })
      .then(function () {
        open();
      })
      .catch(function (err) {
        if (window.console) console.warn('[tgsCart] add failed', err);
      })
      .then(function () {
        setBusy(false);
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
      });
  }

  /* ---------- init ---------- */

  function init() {
    root = $(SELECTORS.root);
    // Wire global listeners regardless — open triggers / forms may exist
    // even if (defensively) the drawer markup is missing.
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('submit', onSubmit);

    window.tgsCart = {
      open: open,
      close: close,
      refresh: refresh
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
